module.exports = __webpack_public_path__ + "img/275-d10b62.png";